import { Duration } from 'date-fns';
import { relativeDateRange } from '../../../utils/dates/relativeDateRange';
import { StrictDateRange } from '../types';

export type DateRangeKey =
  | 'week'
  | '30days'
  | '90days'
  | '180days'
  | '365days'
  | 'all';

export const dateRangeKeyDuration: Record<DateRangeKey, Duration> = {
  week: { weeks: 1 },
  '30days': { days: 30 },
  '90days': { days: 90 },
  '180days': { days: 180 },
  '365days': { days: 365 },
  all: {},
};

/**
 *
 * @param {DateRangeKey} key - The key of the date range to return
 * @returns the corresponding date range with start and end date, or null in the "all" case
 */
export function generateDateRangeFilter(
  key: DateRangeKey
): StrictDateRange | null {
  if (key === 'all') {
    return null;
  }

  return relativeDateRange(dateRangeKeyDuration[key]);
}
